import React, { useContext, useEffect, useState } from 'react';
import { publicationAPI } from "../Redux/services/PublicationService";
import { useParams } from "react-router-dom";
import { GlobalVariablesContext } from "../Infrastructure/provider/GlobalVariablesProvider";
import {queries} from "../Infrastructure/const/queries";

const PostPage = () => {
    const [isChecked, setIsChecked] = useState(false);
    const { id } = useParams();
    const { setHeaderTitle } = useContext(GlobalVariablesContext);

    const { data, isFetching, isError } = publicationAPI.useFetchPublicationQuery(id);
    const [markAsRead] = publicationAPI.useMarkAsReadMutation();

    const isRead = isChecked || Boolean(data?.read_at);

    const makeLinksClickable = (text:any) => {
        if (!text) return "";

        const urlRegex = /(https?:\/\/[^\s]+)/g;

        return text.replace(
            urlRegex,
            (url:any) =>
                `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 underline">${url}</a>`
        );
    };

    useEffect(() => {
        if (data) setHeaderTitle(data.publication.title);
        return () => setHeaderTitle('');
    }, [data]);

    // --- функция скачивания файла через fetch
    const downloadFile = async (file: any) => {
        try {
            const response = await fetch(file.url, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                },
            });

            if (!response.ok) throw new Error('Ошибка скачивания файла');

            const blob = await response.blob(); // ← сразу blob, не arrayBuffer
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.error('Не удалось скачать файл', err);
        }
    };

    if (isFetching) return <p>Загрузка...</p>;
    if (isError) return <p>Ошибка загрузки публикации</p>;

    return (
        <div className="flex flex-col gap-4">
            <div className="bg-white rounded-2xl shadow-md p-6 text-blue-700 italic text-lg leading-relaxed
                            h-[60vh] overflow-y-auto pr-3 flex flex-col whitespace-pre-wrap">
                <p
                    dangerouslySetInnerHTML={{
                        __html: makeLinksClickable(data?.publication.content)
                    }}
                />

                {/* Файлы публикации */}
                {data?.files && data.files.length > 0 && (
                    <div className="mt-6">
                        <h3 className="font-semibold text-blue-800 mb-2">Файли:</h3>
                        <ul className="list-disc ml-5 space-y-1">
                            {data.files.map((file: any, index: number) => (
                                <li key={index}>
                                    <button
                                        onClick={() => downloadFile(file)}
                                        className="text-blue-600 hover:underline cursor-pointer"
                                    >
                                        {file.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {/* Чекбокс "Ознакомлено" */}
                <div className="mt-6 flex items-center gap-3">
                    <button
                        onClick={() => {
                            setIsChecked(true);
                            markAsRead(id);
                            console.log(`Публікація ${id} ознайомлена`);
                        }}
                        disabled={isRead}
                        className={`px-4 py-2 rounded-lg text-white font-semibold transition ${
                            isRead ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'
                        }`}
                    >
                        {isRead ? 'Ознайомлено' : 'Ознайомлений'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PostPage;
